var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "requirement-analysis" }, [
    _c(
      "div",
      {
        staticClass: "flex-column items-center justify-center",
        staticStyle: { width: "1080px", padding: "40px 0 65px" },
      },
      [
        _vm._m(0),
        _c("div", { staticClass: "title-message" }, [
          _vm._v("上传需求，帮您快速拆解需求寻找技术成果"),
        ]),
        _c("div", { staticClass: "content-bg" }, [
          _c("div", { staticClass: "content-box" }, [
            _c(
              "div",
              {
                staticClass:
                  "input-content flex-column items-center justify-between",
                staticStyle: { "padding-right": "14px" },
                style: { width: this.questionId ? "50%" : "100%" },
              },
              [
                _c("el-input", {
                  attrs: {
                    type: "textarea",
                    resize: "none",
                    placeholder:
                      "您可以在这里描述您的需求，例如：\n需求面向产业方向是：xxxxxxxxxxxxxxx；主要解决问题是：xxxxxxxxxxxxxxx；需求方案描述：xxxxxxxxxxxxxxxxxx；\n请推荐几家潜在的可以合作的机构。",
                  },
                  model: {
                    value: _vm.textarea,
                    callback: function ($$v) {
                      _vm.textarea = $$v
                    },
                    expression: "textarea",
                  },
                }),
                _vm.questionId
                  ? _c(
                      "div",
                      { staticClass: "upload-btn" },
                      [
                        _c(
                          "el-button",
                          {
                            style: {
                              padding: this.questionId
                                ? "8px 14px !important"
                                : "10px 14px !important",
                            },
                            attrs: { loading: _vm.keyWordLoading },
                            on: { click: _vm.getDemandDisassembly },
                          },
                          [_vm._v("立即识别")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm.questionId
              ? _c("div", {
                  staticStyle: {
                    height: "100%",
                    width: "0",
                    background: "transparent",
                    "border-left": "1px dashed #EDEDED",
                  },
                })
              : _vm._e(),
            _vm.questionId
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.keyWordLoading,
                        expression: "keyWordLoading",
                      },
                    ],
                    staticClass:
                      "input-content flex-column items-center justify-between",
                    staticStyle: {
                      "padding-left": "14px",
                      "padding-right": "14px",
                    },
                    attrs: {
                      "element-loading-background": "rgba(255, 255, 255, 0.5)",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "right-top",
                        staticStyle: { width: "100%", "flex-shrink": "0" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "flex items-center",
                            staticStyle: { color: "#3860F4" },
                          },
                          [
                            _c("img", {
                              staticStyle: { "margin-right": "5px" },
                              attrs: {
                                src: require("@/assets/images/GuoJiao/question-icon.png"),
                                height: 13,
                                width: 15,
                                alt: "",
                              },
                            }),
                            _vm._v(" 基于大模型的技术需求拆解 "),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            ref: "descContent",
                            staticClass: "descContent",
                            staticStyle: {
                              "max-height": "186px",
                              padding: "7px 0",
                            },
                          },
                          [
                            _vm.keywordList && _vm.keywordList.length
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "field-content",
                                    staticStyle: {
                                      padding: "0",
                                      "max-height": "186px",
                                      "overflow-y": "auto",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.keywordList[0].technology) +
                                        " "
                                    ),
                                  ]
                                )
                              : _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      color: "#00000E45",
                                      "font-size": "14px",
                                      "padding-top": "10px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "先在左侧输入内容，再点击「立即识别」，大模型将自动拆解您的需求～"
                                    ),
                                  ]
                                ),
                          ]
                        ),
                        _c("div", { staticClass: "keyword-input" }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "14px",
                                height: "14px",
                                margin: "10px 0 6px",
                                color: "#181F33",
                              },
                            },
                            [_vm._v("关键词：")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "keyword-box",
                              style: { maxHeight: _vm.keywordHeight + "px" },
                            },
                            [
                              _vm._l(_vm.keywordTags, function (tag, ind) {
                                return _c(
                                  "div",
                                  {
                                    key: ind,
                                    staticClass: "tag-item",
                                    style: {
                                      paddingRight: _vm.isEdit ? "16px" : "8px",
                                    },
                                  },
                                  [
                                    !_vm.isEdit
                                      ? _c("span", {}, [
                                          _vm._v(_vm._s(tag.tagName)),
                                        ])
                                      : _c("el-input", {
                                          staticStyle: { width: "88px" },
                                          attrs: { size: "mini" },
                                          model: {
                                            value: tag.tagName,
                                            callback: function ($$v) {
                                              _vm.$set(tag, "tagName", $$v)
                                            },
                                            expression: "tag.tagName",
                                          },
                                        }),
                                    _vm.isEdit
                                      ? _c(
                                          "el-popconfirm",
                                          {
                                            attrs: {
                                              placement: "top",
                                              "confirm-button-text": "确认",
                                              "cancel-button-text": "取消",
                                              icon: "el-icon-info",
                                              "icon-color": "red",
                                              "popper-class":
                                                "keyword-confirm-delete-gj",
                                              title: "确定删除吗？",
                                            },
                                            on: {
                                              confirm: function ($event) {
                                                return _vm.handleTagClose(tag)
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-close",
                                              attrs: { slot: "reference" },
                                              slot: "reference",
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              }),
                              _vm.isEdit
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "inline-block",
                                        height: "28px",
                                      },
                                    },
                                    [
                                      _vm.tagVisible
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "flex items-center",
                                              staticStyle: {
                                                "flex-wrap": "nowrap",
                                                height: "28px",
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                ref: "saveTagInput",
                                                staticClass: "input-new-tag",
                                                attrs: {
                                                  size: "mini",
                                                  placeholder: "请输入关键词",
                                                },
                                                model: {
                                                  value: _vm.tagValue,
                                                  callback: function ($$v) {
                                                    _vm.tagValue =
                                                      typeof $$v === "string"
                                                        ? $$v.trim()
                                                        : $$v
                                                  },
                                                  expression: "tagValue",
                                                },
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "operation-btn pointer",
                                                  staticStyle: {
                                                    color: "#3860F4",
                                                    "margin-left": "8px",
                                                  },
                                                  on: {
                                                    click: _vm.handleTagConfirm,
                                                  },
                                                },
                                                [_vm._v("确定")]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "operation-btn pointer",
                                                  staticStyle: {
                                                    color: "rgba(0,0,0,0.65)",
                                                  },
                                                  on: {
                                                    click: () => {
                                                      _vm.tagValue = ""
                                                      _vm.tagVisible = false
                                                    },
                                                  },
                                                },
                                                [_vm._v("取消")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _c(
                                            "span",
                                            {
                                              staticClass: "button-new-tag",
                                              on: { click: _vm.showInput },
                                            },
                                            [_vm._v("+ 添加")]
                                          ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "goDetails-btn flex items-center justify-between",
                        staticStyle: { width: "100%", "flex-shrink": "0" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "flex items-center update-btn no-wrap",
                          },
                          [
                            _vm._v(" 请确保关键词是否正确？ "),
                            _c(
                              "el-button",
                              {
                                staticStyle: { color: "#3860F4" },
                                attrs: {
                                  type: "text",
                                  loading: _vm.updateLoading,
                                },
                                on: { click: _vm.handleEdit },
                              },
                              [
                                _vm._v(
                                  _vm._s(!_vm.isEdit ? "点击修改" : "点击保存")
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "span",
                          { staticClass: "submit-btn" },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { loading: false },
                                on: { click: _vm.goDetail },
                              },
                              [_vm._v("生成报告")]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "upload-btn-primary" },
          [
            _vm.questionId
              ? _c("div", { staticStyle: { height: "36px" } })
              : _c(
                  "el-button",
                  {
                    attrs: { loading: _vm.keyWordLoading },
                    on: { click: _vm.getDemandDisassembly },
                  },
                  [_vm._v("立即识别")]
                ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title-box" }, [
      _c("div", { staticClass: "ai-icon" }),
      _c("div", { staticClass: "title-icon" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }